import PropTypes from "prop-types"

const UserDetailsShape = {
  userDetails: PropTypes.shape({
    authenticated: PropTypes.bool.isRequired,
    culture: PropTypes.string,
    theme: PropTypes.string,
    client: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      subdomain: PropTypes.string,
      availableCultures: PropTypes.arrayOf(PropTypes.shape({
        Code: PropTypes.string,
        Name: PropTypes.string,
      })),
    }),
  }).isRequired,
}
export default UserDetailsShape



// WEBPACK FOOTER //
// ./src/state/shapes/UserDetailsShape.js